import { IconButtonSizeType, IconButtonVariantType, } from '../../../../../../components/iconButton/types/iconButton';
import { IconButtonStateType } from '../../../../../../components/iconButton/types/state';
import { commonStyles, containerCommonStyles } from '../commonStyles';
const LARGE_CONTAINER_COMMON_TOKENS = (FOUNDATIONS, SHADOWS) => ({
    ...containerCommonStyles(FOUNDATIONS),
    border_radius: FOUNDATIONS.radius_1000,
    padding: FOUNDATIONS.spacing_125,
    box_shadow: SHADOWS.shadow_110,
});
const MEDIUM_CONTAINER_COMMON_TOKENS = (FOUNDATIONS, SHADOWS) => ({
    ...containerCommonStyles(FOUNDATIONS),
    border_radius: FOUNDATIONS.radius_1000,
    padding: FOUNDATIONS.spacing_100,
    box_shadow: SHADOWS.shadow_110,
});
const SMALL_CONTAINER_COMMON_TOKENS = (FOUNDATIONS, SHADOWS) => ({
    ...containerCommonStyles(FOUNDATIONS),
    display: 'flex',
    border_radius: FOUNDATIONS.radius_1000,
    padding: FOUNDATIONS.spacing_100,
    box_shadow: SHADOWS.shadow_110,
});
const LARGE_ICON_COMMON_TOKENS = (FOUNDATIONS) => ({
    width: FOUNDATIONS.size_350,
    height: FOUNDATIONS.size_350,
});
const MEDIUM_ICON_COMMON_TOKENS = (FOUNDATIONS) => ({
    width: FOUNDATIONS.size_300,
    height: FOUNDATIONS.size_300,
});
const SMALL_ICON_COMMON_TOKENS = (FOUNDATIONS) => ({
    width: FOUNDATIONS.size_200,
    height: FOUNDATIONS.size_200,
});
export const getSecondaryFilledStyles = (FOUNDATIONS, SHADOWS) => {
    return {
        [IconButtonVariantType.SECONDARY_FILLED]: {
            [IconButtonSizeType.SMALL]: {
                [IconButtonStateType.DEFAULT]: {
                    ...commonStyles(FOUNDATIONS),
                    container: {
                        ...SMALL_CONTAINER_COMMON_TOKENS(FOUNDATIONS, SHADOWS),
                        background_color: FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_default_bg,
                        border: `1px solid ${FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_default_border}`,
                    },
                    icon: {
                        ...SMALL_ICON_COMMON_TOKENS(FOUNDATIONS),
                        color: FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_default_icon,
                    },
                },
                [IconButtonStateType.HOVER]: {
                    ...commonStyles(FOUNDATIONS),
                    container: {
                        ...SMALL_CONTAINER_COMMON_TOKENS(FOUNDATIONS, SHADOWS),
                        background_color: FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_hover_bg,
                        border: `1px solid ${FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_hover_border}`,
                    },
                    icon: {
                        ...SMALL_ICON_COMMON_TOKENS(FOUNDATIONS),
                        color: FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_hover_icon,
                    },
                },
                [IconButtonStateType.PRESSED]: {
                    ...commonStyles(FOUNDATIONS),
                    container: {
                        ...SMALL_CONTAINER_COMMON_TOKENS(FOUNDATIONS, SHADOWS),
                        background_color: FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_pressed_bg,
                        border: `1px solid ${FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_pressed_border}`,
                    },
                    icon: {
                        ...SMALL_ICON_COMMON_TOKENS(FOUNDATIONS),
                        color: FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_pressed_icon,
                    },
                },
                [IconButtonStateType.DISABLED]: {
                    ...commonStyles(FOUNDATIONS),
                    container: {
                        ...SMALL_CONTAINER_COMMON_TOKENS(FOUNDATIONS, SHADOWS),
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        cursor: 'default',
                    },
                    icon: {
                        ...SMALL_ICON_COMMON_TOKENS(FOUNDATIONS),
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                },
            },
            [IconButtonSizeType.MEDIUM]: {
                [IconButtonStateType.DEFAULT]: {
                    ...commonStyles(FOUNDATIONS),
                    container: {
                        ...MEDIUM_CONTAINER_COMMON_TOKENS(FOUNDATIONS, SHADOWS),
                        background_color: FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_default_bg,
                        border: `1px solid ${FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_default_border}`,
                    },
                    icon: {
                        ...MEDIUM_ICON_COMMON_TOKENS(FOUNDATIONS),
                        color: FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_default_icon,
                    },
                },
                [IconButtonStateType.HOVER]: {
                    ...commonStyles(FOUNDATIONS),
                    container: {
                        ...MEDIUM_CONTAINER_COMMON_TOKENS(FOUNDATIONS, SHADOWS),
                        background_color: FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_hover_bg,
                        border: `1px solid ${FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_hover_border}`,
                    },
                    icon: {
                        ...MEDIUM_ICON_COMMON_TOKENS(FOUNDATIONS),
                        color: FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_hover_icon,
                    },
                },
                [IconButtonStateType.PRESSED]: {
                    ...commonStyles(FOUNDATIONS),
                    container: {
                        ...MEDIUM_CONTAINER_COMMON_TOKENS(FOUNDATIONS, SHADOWS),
                        background_color: FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_pressed_bg,
                        border: `1px solid ${FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_pressed_border}`,
                    },
                    icon: {
                        ...MEDIUM_ICON_COMMON_TOKENS(FOUNDATIONS),
                        color: FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_pressed_icon,
                    },
                },
                [IconButtonStateType.DISABLED]: {
                    ...commonStyles(FOUNDATIONS),
                    container: {
                        ...MEDIUM_CONTAINER_COMMON_TOKENS(FOUNDATIONS, SHADOWS),
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        cursor: 'default',
                    },
                    icon: {
                        ...MEDIUM_ICON_COMMON_TOKENS(FOUNDATIONS),
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                },
            },
            [IconButtonSizeType.LARGE]: {
                [IconButtonStateType.DEFAULT]: {
                    ...commonStyles(FOUNDATIONS),
                    container: {
                        ...LARGE_CONTAINER_COMMON_TOKENS(FOUNDATIONS, SHADOWS),
                        background_color: FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_default_bg,
                        border: `1px solid ${FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_default_border}`,
                    },
                    icon: {
                        ...LARGE_ICON_COMMON_TOKENS(FOUNDATIONS),
                        color: FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_default_icon,
                    },
                },
                [IconButtonStateType.HOVER]: {
                    ...commonStyles(FOUNDATIONS),
                    container: {
                        ...LARGE_CONTAINER_COMMON_TOKENS(FOUNDATIONS, SHADOWS),
                        background_color: FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_hover_bg,
                        border: `1px solid ${FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_hover_border}`,
                    },
                    icon: {
                        ...LARGE_ICON_COMMON_TOKENS(FOUNDATIONS),
                        color: FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_hover_icon,
                    },
                },
                [IconButtonStateType.PRESSED]: {
                    ...commonStyles(FOUNDATIONS),
                    container: {
                        ...LARGE_CONTAINER_COMMON_TOKENS(FOUNDATIONS, SHADOWS),
                        background_color: FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_pressed_bg,
                        border: `1px solid ${FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_pressed_border}`,
                    },
                    icon: {
                        ...LARGE_ICON_COMMON_TOKENS(FOUNDATIONS),
                        color: FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_pressed_icon,
                    },
                },
                [IconButtonStateType.DISABLED]: {
                    ...commonStyles(FOUNDATIONS),
                    container: {
                        ...MEDIUM_CONTAINER_COMMON_TOKENS(FOUNDATIONS, SHADOWS),
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        cursor: 'default',
                    },
                    icon: {
                        ...LARGE_ICON_COMMON_TOKENS(FOUNDATIONS),
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                },
            },
        },
    };
};
//# sourceMappingURL=secondaryFilled.js.map